export default class Channel {
	public element: HTMLElement;
	public number: string;
	public name: string;
	public keywords: string;
	public tvEverywhere: boolean;
	public visible: boolean = true;

	constructor({ element }: { element: Element; }) {
		this.element = element as HTMLElement;
		this.number = this.element.getAttribute('data-channel-number') || '';
		this.name = this.element.getAttribute('data-channel-name') || '';
		this.keywords = this.element.getAttribute('data-channel-keywords') || '';
		this.tvEverywhere = this.element.getAttribute('data-tv-everywhere') === 'true';
	}

	public filter = ({ filterString, tvEverywhere }: {
		filterString: string;
		tvEverywhere: boolean;
	}) => {
		// Replace spaces with RegEx OR
		const filterRegex = new RegExp(filterString.replace(/\s/g, '|'), 'i');
		if ((filterString === ''
			|| filterRegex.test(this.number)
			|| filterRegex.test(this.name)
			|| filterRegex.test(this.keywords))
			&& (tvEverywhere === false || this.tvEverywhere === true)) {
			this.visible = true;
			this.element.classList.remove('channel--hidden');
		} else {
			this.visible = false;
			this.element.classList.add('channel--hidden');
		}
	}
}
